@if (toasts.message(); as msg) {
  @if (msg.kind === 'error') {
    <div class="toast toast--error" role="alert">
      <div class="toast__body">
        <p class="toast__text">{{ msg.text }}</p>
        @if (msg.reason) {
          <p class="toast__reason">{{ msg.reason }}</p>
        }
        @if (msg.details) {
          <button
            type="button"
            class="toast__toggle"
            [attr.aria-expanded]="expanded()"
            (click)="toggleDetails()"
          >
            {{ expanded() ? i18n.t('errors.hideDetails') : i18n.t('errors.showDetails') }}
          </button>
          @if (expanded()) {
            <pre class="toast__details" tabindex="0">{{ msg.details }}</pre>
          }
        }
      </div>
      <button
        type="button"
        class="toast__close"
        [attr.aria-label]="i18n.t('common.close')"
        (click)="toasts.dismiss()"
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M4 4l8 8M12 4l-8 8"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  } @else {
    <div class="toast" role="status" aria-live="polite">{{ msg.text }}</div>
  }
}
